import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import Header from './Header';

import NotificationRow from './NotificationRow';
import QueryRow from './QueryRow';
import AlertNameRow from './AlertNameRow';
import SendAlertsToRow from './SendAlertsToRow';
import FrequencyRow from './FrequencyRow';
import TriggerModeRow from './TriggerModeRow';
import BasicContent from './BasicContent';
import AdvancedContent from './AdvancedContent';
import PreFooter from './PreFooter';
import Footer from './Footer';
import { InfoTooltipOnClick, TooltipConstants } from '@Components/InfoTooltip';

import './AlertCreateDialog.custom.scss';
import './AlertCreateDialog.theme.scss';

export default function AlertCreateDialog (props) {
  const { className, alertsInfo, basicContentAvailable } = props;

  return (
    <GeneralDialogLayout
      {...props}
      className={classnames([className, 'create-alert-dialog'])}
      contentClassName='create-alert-dialog-content-wrapper'
      headerClassName='create-alert-dialog-header'
      header={
        <Header {...props} />
      }
      footerClassName='create-alert-dialog-footer'
      footer={
        <Footer {...props} />
      }
    >
      <NotificationRow {...props} />
      <QueryRow {...props} />
      {alertsInfo && <>
        <AlertNameRow {...props} />
        <SendAlertsToRow {...props} />
        <FrequencyRow {...props} />
        <TriggerModeRow {...props} />
        {basicContentAvailable &&
          <BasicContent {...props} />
        }
        <AdvancedContent {...props} />
        <PreFooter {...props} />
      </>}
      <InfoTooltipOnClick
        id={TooltipConstants.ids.AlertCreateDialog}
      />
    </GeneralDialogLayout>
  );
}

AlertCreateDialog.propTypes = {
  className: PropTypes.string,
  alertsInfo: PropTypes.object,
  basicContentAvailable: PropTypes.bool,
};
